// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"984daaab","389":"c1b151e3","453":"415cd877","455":"29375e87","977":"d0c0c450"}[chunkId] + ".chunk.js";
};